module.exports = __webpack_public_path__ + "img/f79b6301ac6e43f4b0f2fe99aac20a8b.d829bd4e.jpg";